import { initialize } from 'ldclient-js';
import queryString from 'query-string';

let ldclient;
let settings = {
  // Causes analytics events for feature flags to be sent only when you call `variation`.
  // Otherwise, the default behavior is to also send events when the flags are loaded.
  sendEventsOnlyForVariation: true,
  enabled: false,
  // Removes all user data from calls to launch darkly except for the user key
  // But still allows us to target feature flags based on user data.
  allAttributesPrivate: true,
  // Provides data about why a user received their variation
  evaluationReasons: true,
};

export default {
  configure(opts = {}) {
    settings = {
      ...settings,
      ...opts,
    };

    return settings;
  },

  boot() {
    if (!settings.clientID) {
      return;
    }

    ldclient = initialize(settings.clientID, settings.user, {
      bootstrap: settings.bootstrap,
      sendEventsOnlyForVariation: settings.sendEventsOnlyForVariation,
      allAttributesPrivate: settings.allAttributesPrivate,
    });
  },

  // key is the key identifier of the feature flag key in LaunchDarkly
  // and callback is a function that expects the old and new value
  // LaunchDarkly.subscribe('ld-key', (current, previous) => {});
  subscribe(key, callback) {
    if (typeof callback !== 'function') return;

    ldclient.on(`change:${key}`, callback);
  },

  getAllFlags() {
    return ldclient && ldclient.allFlags();
  },

  getVariant(key, defaultValue = false) {
    //Allows you to force a variant by appending to the url, eg: #ab_experiment-key=true
    const matches = queryString.parse(location.hash);
    const value = matches.ab_all || matches[`ab_${key}`];
    if (value) {
      if (['true', 'false'].includes(value)) {
        return value === 'true';
      }

      return value;
    }

    if (!settings.enabled || !ldclient) {
      return defaultValue;
    }

    return ldclient.variation(key, defaultValue);
  },
};
